// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/lib/index.js??ref--6-2!./text.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("b55dbc5a", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/text.css
// module id = Rn48
// module chunks = 45